import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleMasInformacion = React.lazy(
  () =>
    import(
      "../components/task/TareaDetalleMasInformacion/tarea-detalle-mas-informacion"
    )
);
export function tareaDetalleMasInformacion() {
  return (
    <Route
      path="/tarea-detalle-mas-informacion"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <TareaDetalleMasInformacion />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
